import React from 'react';

const LINKS = [
    {href: '#services', title: 'I’m looking for support', text: 'Understand your care options'},
    {href: '#refer-a-client', title: 'I want to refer someone', text: 'Explore the referral pathway'},
    {href: '#existing-client', title: 'I’m already a client', text: 'Contact the office about your care'},
];

const QuickLinks = () => (
    <div className="sw-quick">
        {LINKS.map((link) => (
            <a key={link.href} href={link.href} className="sw-quick__item">
                <strong>{link.title}</strong>
                <span>{link.text}</span>
            </a>
        ))}
    </div>
);

export default QuickLinks;
